import React from 'react';
import { motion } from 'framer-motion';

const PageTransition = ({ children }) => {
  return (
    <motion.divs
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ 
        duration: 0.3,
        ease: [0.6, -0.05, 0.01, 0.99]
      }}
      style={{ width: '100%' }}
    >
      {children}
    </motion.divs>
  );
};

export default PageTransition;
